import EquipmentCalculatedAlertsEqualsComparatorEditor from "./EquipmentCalculatedAlertsEqualsComparatorEditor.js";
import EquipmentCalculatedAlertsEqualsComparator from "./EquipmentCalculatedAlertsEqualsComparator.js";
import EquipmentCalculatedAlertsEqualsComparatorFilterConverter from "./EquipmentCalculatedAlertsEqualsComparatorFilterConverter.js";
export default {
  install(molten) {
    molten.addPlugin('AttributeConditionComparator', EquipmentCalculatedAlertsEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: EquipmentCalculatedAlertsEqualsComparator.TYPE,
      editor: EquipmentCalculatedAlertsEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', EquipmentCalculatedAlertsEqualsComparatorFilterConverter);
  }
};